"use client";

import { Clock } from "lucide-react";

export function TimeSlider() {
  return (
    <label className="absolute bottom-4 left-4 z-20 flex w-[min(28rem,calc(100%-2rem))] items-center gap-3 rounded-md border border-white/15 bg-black/65 px-3 py-2 text-sm backdrop-blur">
      <Clock className="h-4 w-4 text-amber-300" aria-hidden />
      <span className="hidden text-muted-foreground sm:inline">Time window</span>
      <input
        type="range"
        min="1"
        max="14"
        defaultValue="7"
        className="h-2 flex-1 accent-red-400"
        aria-label="Filter map by time window"
      />
      <span className="text-xs text-muted-foreground">14d</span>
    </label>
  );
}
